import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Divider } from '@mui/material';

import { Button } from '../../common/button';

const BlockerDialog = ({ blocker }) => (
    <Dialog
        open={ blocker.state === 'blocked' }
        onClose={ () => blocker.reset() }
        PaperProps={ {
            sx: { borderRadius: 2 }
        } }
        maxWidth={ 'xs' }
    >
        <DialogTitle sx={ { pb: 2, fontWeight: 600 } }>
            Masz niezapisane zmiany.
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                Czy na pewno chcesz opuścić tę stronę? Niezapisane dane zostaną utracone.
            </DialogContentText>
        </DialogContent>

        <Divider/>

        <DialogActions sx={ { p: 2, gap: 1 } }>
            <Button variant="outlined" onClick={ () => blocker.reset() }>
                Zostań
            </Button>
            <Button onClick={ () => blocker.proceed() }>
                Opuść bez zapisu
            </Button>
        </DialogActions>
    </Dialog>
);

export default BlockerDialog;